module.exports = __webpack_public_path__ + "img/Humanist_old.fd52337b.png";